import React = require('react')
import ReactDOM = require('react-dom')

import { ContactForm } from './ContactForm'
import { IWizard, DETAILS_INDEX } from './models'
import { Wizard } from './Wizard'

var repairWizard = document.getElementsByClassName('cc-repair__wizard')[0];

if (repairWizard) {

    var quoteRequestsFeedUrl = "https://spreadsheets.google.com/feeds/list/1Z5OoEvonfOATB7aFwuIXOmWT4HQQtn5xbHf0syxCaX0/oonvhr3/private/full";
    var repairRequestsFeedUrl = "https://spreadsheets.google.com/feeds/list/1Z5OoEvonfOATB7aFwuIXOmWT4HQQtn5xbHf0syxCaX0/omdzwc0/private/full";

    var isDealer = window.location.pathname.indexOf("/dealer.html") == 0;
    if (isDealer) {
        quoteRequestsFeedUrl = "https://spreadsheets.google.com/feeds/list/1BMkFDBcS466AiANx4lV95hYJjwDlBk5yi4ofmFAD_As/od6/private/full";
        repairRequestsFeedUrl = "https://spreadsheets.google.com/feeds/list/1BMkFDBcS466AiANx4lV95hYJjwDlBk5yi4ofmFAD_As/o3ha40t/private/full";
    }

    var wizardDataUrl = 'http://cellclinic.s3-website-eu-west-1.amazonaws.com/wizard.json';

    if (window.location.hostname == 'cellclinic.co.za' || window.location.hostname == 'www.cellclinic.co.za') {
        wizardDataUrl = '/wizard.json';
    }

    $.getJSON(wizardDataUrl, function (wizardData : IWizard) {
    // $.getJSON('https://cellclinic.firebaseio.com/wizard.json', function (wizardData) {
    // $.getJSON('http://www.cellclinic.co.za.global.prod.fastly.net/wizard.json', function (wizardData) {

        if (isDealer) {
            // Remove the personal details question from the Dealer's wizard
            wizardData.questions.splice(DETAILS_INDEX, 1);
        }

        ReactDOM.render(<Wizard
            data={wizardData}
            quoteRequestsFeedUrl={quoteRequestsFeedUrl}
            repairRequestsFeedUrl={repairRequestsFeedUrl}
        />, repairWizard);
    });

}

var contactForm = document.getElementsByClassName('cc-contact-form-container')[0];

if (contactForm) {
    ReactDOM.render(<ContactForm />, contactForm);
}
